import { render, staticRenderFns } from "./GovAffairs.vue?vue&type=template&id=3755a376&"
import script from "./GovAffairs.vue?vue&type=script&lang=js&"
export * from "./GovAffairs.vue?vue&type=script&lang=js&"
import style0 from "./GovAffairs.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports